export const INCLUDE_SIGNATURE = 'INCLUDE_SIGNATURE';
export const INCLUDE_SIGNATURE_PRE_SUCCESS = 'INCLUDE_SIGNATURE_PRE_SUCCESS';
export const INCLUDE_SIGNATURE_SUCCEEDED = 'INCLUDE_SIGNATURE_SUCCEEDED';
export const INCLUDE_SIGNATURE_FAILED = 'INCLUDE_SIGNATURE_FAILED';

export const SIGNATURE_PAYMENT = 'payment';
export const SIGNATURE_OPEN_CASE = 'open-case';
